<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <!-- <div class="card" style="padding: 30px;height: 90vh;overflow-y: scroll;margin-top: -30px;">
    <div class="card-body" style="margin-top: -40px;"> -->
  <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army </span>
    <span class="text-black-50 fs-3 fw-bold">(Survey)</span>
  </div>
    
    <div class="row justify-content-center" style="padding-top: 30px;">
      <div class="col-12 text-start">
      <i class="fas fa-location-dot fa-xl" :style="{ 'color': (lat!=0.00?'#00C300':'red') }"></i>
      {{ lat+","+lng }}

      <button type="button" class="btn btn-primary" @click="getLocation();">
        <i class="fa-solid fa-arrows-rotate" ></i>
      </button>
      
      
      <!-- https://www.google.com/maps/search/?api=1&query=40.748817,-73.985428 -->

      <a :href="'https://www.google.com/maps/search/?api=1&query='+lat+','+lng+''" target="_blank" v-if="lat!=0.00">See in a map</a>
      </div>
    </div>
    <br>
        <div class="row" style="padding: 0px 5px 0px 5px">
            <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold " style="font-size: 12px;">Survey group</span>
            </label>
            </div>
            <div class="col-8 " style="height: 35px;">
                        <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <span style="font-size: 12px;">{{ selectedSurveyGroupType==0?"Please select": selectedSurveyGroupData.name_la}}</span>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                          <li v-for="(groupData,index) in surveyGroupDdl" v-bind:key="index" @click="getQuestionsAndChoices(groupData.id,groupData);">&nbsp;{{groupData.name_la}}&nbsp;</li>
                        </ul>
            </div>
        </div>
        <hr>
        <div class="row" style="padding: 3px 5px 0px 5px;height: 40vh;overflow-y: scroll;">
         <!-- T3st {{ surveyObject['surveyGroup'+selectedSurveyGroupType] }} -->
        <div v-if="selectedSurveyGroupType!=0&&surveyObject['surveyGroup'+selectedSurveyGroupType]" >
            <div v-for="(questionData, index) in surveyObject['surveyGroup'+selectedSurveyGroupType]" v-bind:key="index">
            <div class="row">
              <!-- Filter only question to show -->
              <div v-if="index==0||surveyObject['surveyGroup'+selectedSurveyGroupType][index-1].q_id!=questionData.q_id" class="col-xs-12 offset-sm-2 col-sm-10 text-start">
                <div v-if="index!=0"><hr></div>
                <span style="font-size:12px"><b>{{ (index+1)+'.'+questionData.question_msg_la +"?"}}</b></span>
              </div>
            </div>
            <div class="row" v-for="(choice, index) in questionData.choices" v-bind:key="index">
              <div class="col-xs-12 offset-sm-2 col-sm-10">
                <div class="form-check form-switch text-start">
                  <input class="form-check-input" type="checkbox" v-model="choice.selected" @click="clickChoice(choice,questionData.choices);">
                  <label class="form-check-label" for="flexSwitchCheckDefault" style="font-size:12px">{{ choice.choice_msg_la + (choice.is_single_choice?'(Only this Choice)':'')}}</label>
                </div>
              </div>
            </div>  
            </div>
        </div>
        </div>
        <div v-if="selectedSurveyGroupType!=0">
          
        <hr>
        <div class="row" style="padding: 3px 5px 0px 5px">
                  <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold " style="font-size: 12px;">Customer name</span>
                    </label>
                  </div>
                  <div class="col-8" style="height: 35px;overflow-y: hidden;">
                    <input type="text" class="form-control" style="width: 100%;height: 35px;font-size: 12px;" v-model="custName">
                  </div>
        </div>
        <div class="row" style="padding: 3px 5px 0px 5px">
                  <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold " style="font-size: 12px;">Phone Number1</span>
                    </label>
                  </div>
                  <div class="col-8" style="height: 35px;overflow-y: hidden;">
                    <input type="number" class="form-control" style="width: 100%;height: 35px;font-size: 12px;" v-model="phoneNumber">
                  </div>
        </div>   
        <div class="row" style="padding: 3px 5px 0px 5px">
                  <div class="col-4 " style="background-color: #EAEDED;height: 50px;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold " style="font-size: 12px;">Village<br>
                      (Optional)</span>
                    </label>
                  </div>
                  <div class="col-8" style="height: 50px;overflow-y: hidden;">
                    <textarea class="form-control" style="width: 100%;height: 50px;font-size: 12px;" aria-label="With textarea" v-model="remarkAddress"></textarea>
                  </div>
        </div>    
        </div> 
    <!-- </div>
    </div> -->
    <hr>
        <div class="row" style="padding: 0px 5px 0px 5px">
            <div class="col-12 text-center">
              <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:50%;" >
              <i class="fas fa-house"></i> Home
            </button>
            <button v-if="selectedSurveyGroupType!=0" type="submit" class="btn btn-success" style="width:50%;" @click="clickSave();">
              <i class="fas fa-floppy-disk"></i> Send
            </button>
            </div>
            <!-- <div class="col-6 text-center">
            <button v-if="selectedSurveyGroupType!=0" type="submit" class="btn btn-success" style="width:100%;" @click="clickSave();">
              <i class="fas fa-floppy-disk"></i> Send
            </button>
            </div> -->
        </div>
    </div>
    
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'SurveyPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
      lat:0.00,
      lng:0.00,
      surveyGroupDdl:Global.surveyGroup,
      // {type1:"Normal Customer & Shop Dealer",type2:"FTTH Customer",type3:"Merchant M-money"},
      // questionCType1:[],
      // questionCType2:[],
      // questionCType3:[],
      selectedSurveyGroupType:0,
      selectedSurveyGroupData:{},
      startDate:null,
      remarkAddress:"",
      custName:"",
      phoneNumber:"",
      surveyObject:{}

    };
  },
  mounted:async function() {
    var vm = this;
    // vm.getLocation();
    // vm.getQuestionsAndChoices();
    // if(Global.surveyGroup.length==0){
      var surveyGroupResult = await vm.getSurveyGroup(null,true);
      if(surveyGroupResult.status==200&&surveyGroupResult.statusText=="OK"&&surveyGroupResult.data.result){
        Global.surveyGroup = surveyGroupResult.data.result;
        vm.surveyGroupDdl = surveyGroupResult.data.result;
      }
    // }
  },
  methods: {
   verifyOtp: function(){
    this.$router.push("/home");
   },
  getLocation: function() {
    var vm = this;
    vm.showLoading();
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
  } else {
    setTimeout(() => {
      vm.hideLoading();
    }, 1000);
    alert("Geolocation is not supported by this browser.");
  }
  },
  showPosition: function(position) {
    var vm = this;
    vm.lat = position.coords.latitude;
    vm.lng = position.coords.longitude;
    vm.hideLoading();
  },
  showError:function(error) {
    switch(error.code) {
      case error.PERMISSION_DENIED:
        alert("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        alert("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        alert("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        alert("An unknown error occurred.");
        break;
    }
  },
  clickSaveMockup:function(){
    var vm = this;
    if(vm.validateForm()){

      vm.$swal.fire({
        title: 'Do you want to send data?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Send',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.$swal.fire('Completed!', '', 'success')
          vm.selectedSurveyGroupType = 0;
        } else if (result.isDenied) {
          // this.$swal.fire('Changes are not saved', '', 'info')
        }
      });
          
    }else{
      vm.$swal.fire({
        icon: 'error',
        title: 'Warning!',
        text: 'Please select customer type and do survey!',
        // footer: '<a href="">Why do I have this issue?</a>'
      })
            
    }
      
    },
  validateForm:function(){
    var flag = true;
    if(this.selectedSurveyGroupType==0){
        flag = false;
    }
    return flag
  },
  getQuestionsAndChoices: async function(groupType,groupData){
    var vm = this;
    // stamp start date time!
    var d = new Date();
    vm.startDate = d.getTime();

    vm.selectedSurveyGroupType = groupType;
    vm.selectedSurveyGroupData = groupData;

    var userObject = JSON.parse(localStorage.getItem("userObj"));
    var jsonRequest = {};
    var userDistrictsIdArray = userObject.districts_id.split(",")
    jsonRequest.userProvinceId=userObject.province_id;
    jsonRequest.userDistrictsId=userObject.districts_id;
    jsonRequest.custType=groupType;
    if(!vm.surveyObject['surveyGroup'+groupType]||vm.surveyObject['surveyGroup'+groupType].length==0){
    vm.showLoading();
      return await axios.post(Global.backendPath+"question/getQuestionsAndChoices", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          var results = response.data.result;
              //Check user area is in Question and choice area first item or not!
              var questionFirstItem = results[0];
              //District comma in Question choice's first item.
              var questionDistrictsArray = (questionFirstItem.districts_id).split(",");
              //Find user district in Quest area district.
              var sameDistrictArray = userDistrictsIdArray.filter(value => (questionDistrictsArray).includes(value));
              if(sameDistrictArray.length>0){
                vm.surveyObject['surveyGroup'+groupType]=results;
              }else{
                vm.surveyObject['surveyGroup'+groupType]=[];
              }
          
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
    }
   },
  clickChoice:function(currentChoice,allChoice){
    if(currentChoice.is_single_choice){
      //set uncheck for other is not single
      allChoice.forEach(function(item){
        if(currentChoice.q_id!=item.q_ud&&currentChoice.c_id!=item.c_id){
          item.selected=false;
        }
      });
    }else{
      //set uncheck single 
      allChoice.forEach(function(item){
        if(item.is_single_choice&&currentChoice.q_id!=item.q_ud&&currentChoice.c_id!=item.c_id){
          item.selected=false;
        }
      });
    }
  },
  clickSave:function(){
    var vm = this;
    var validationObject = vm.validateFormSave();
    if(!validationObject.flag){
      vm.$swal.fire('Please prepare the information to save!', validationObject.msg, 'error');
    }else{
      vm.$swal.fire({
        title: 'Do you want to send data?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Send',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.save();
        } 
      });
    }

  },
  validateFormSave:function(){
    var flag = true,
    vm = this,
    msg = "";
    if(vm.surveyObject['surveyGroup'+vm.selectedSurveyGroupType].length==0){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> You have no question now! </div><br>";
    }
    if(!vm.lat||vm.lat==0){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Please refresh your current location! </div><br>";
      
    }
    // if(!vm.custName){
    //   flag = false;
    //   msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Customer name must be typing! </div><br>";
    // }
    // if(!vm.phoneNumber){
    //     flag = false;
    //     msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Custoner phone number must be typing! </div><br>";
    // }    
    
    return {"flag":flag,"msg":msg};
  },
  save:function(){
    var vm = this;
    vm.showLoading();
    var d = new Date();
    var userObject = JSON.parse(localStorage.getItem("userObj"));
    var jsonRequest = 
    {
      "survey":{
                startDate: vm.startDate,
                endDate: d.getTime(),
                remarkAddress:vm.remarkAddress, 
                custName:vm.custName,
                phoneNumber:vm.phoneNumber,
                userId:userObject.id,
                lat:vm.lat,
                lng:vm.lng,
                surveyGroupId:vm.selectedSurveyGroupType,
                userPhoneNumber:userObject.phone_number
              },
      "surveyAnswer":vm.surveyObject['surveyGroup'+vm.selectedSurveyGroupType]
    };
    axios.post(Global.backendPath+"survey/saveSurvey", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"){
          vm.$swal.fire('Completed!', '', 'success')
          vm.resetPage();
        //   vm['questionCType'+custType]=response.data.result;
        }else{
          vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: 'Error!',
            // footer: '<a href="">Why do I have this issue?</a>'
          })
        }
      }).catch((error) => {
        vm.$swal.fire({
            icon: 'error',
            title: 'Warning!',
            text: "Can't save!",
            footer: 'Please contact to your system admin!'
        });
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   
    

  },
  validateLocation: function(){
    var vm = this;
    if(!vm.lat||vm.lat==0){
      return false;
    }else{
      return true
    }
  },
  resetPage:function(){
    var vm = this;
    vm.surveyObject={};
    vm.selectedSurveyGroupType=0;
    vm.startDate=null;
    vm.remarkAddress="";
    vm.custName="";
    vm.phoneNumber="";
    vm.lat=0.00;
    vm.lng=0.00;
  }
}
}

</script>

<style scoped>
.otp-keypad {
  max-width: 50%;
  margin: 0 auto;
}

.otp-keypad-button {
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  border: none;
  outline: none;
  color: #333;
}

.otp-keypad-empty-space {
  height: 60px;
  width: 60px;
  background-color: transparent;
}

.nav-link.active {
  background-color: gray;
}
</style>
